import { useTranslation } from 'react-i18next'
import { useSpotSwapUserConfig } from '~/state/dex/hooks'
import { StyledDetailWrapper } from '~/components/Exchange/styled'
import { StyledDividerLite, StyledDetailValue } from '../styled'

const RecipientPreview = () => {
  const { t } = useTranslation()
  const { recipient } = useSpotSwapUserConfig()

  return (
    <>
      <StyledDividerLite />
      <StyledDetailWrapper>
        <span>{t('recipient_address')}</span>
        <StyledDetailValue>{recipient}</StyledDetailValue>
      </StyledDetailWrapper>
    </>
  )
}

export default RecipientPreview
